//
// ContentService.js
//
// author: marcio.garcia@newsoftware.com.br
//

import axios from 'axios';


import { menu } from '../defs/menu'
import { pages } from '../defs/pages'

const urlToken = 'http://localhost:8001/auth/token/request/';
const urlContent = 'http://localhost:8003/content/request/';  

const ContentService = {

    invokeToken(workspace, userName, password){
        var config = {
            method: 'POST',
            url: urlToken+workspace,
            headers: {
                'Content-Type': 'application/json'
            },
            data: { 
                 "username": userName, "password": password
            }
        };
        return axios(config);

    },

    invokeContent2(workspace, value) {
        var token = 'Bearer '+global.config.restGateway.token;
        var config = {
            method: 'GET',
            url: urlContent +workspace +'/' +value,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
              }
        };
        return axios(config);
    },

    getContentList(request) {
        if (request === 'menu') {
            return menu;
        }
        return "";
    },

    getContentItem( value) {
        var find = pages.find(it => (it.id === value));
        if (find)
           return {
                id: find.id,
                title: find.title,
                breadcrumb: [],
                desc: find.desc,
                text: '',
                childs: []
            };
        else
            return {
                title: 'Page not found',
                breadcrumb: [],
                desc: 'The requested page could not be found [' + value + ']',
                text: '404 CODE, if you entered a web address please check it was correct',
                childs: []
            };
    }
};
export default ContentService;

